var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import moment from 'moment';
import React, { useContext } from 'react';
import { useBottomScrollListener } from 'react-bottom-scroll-listener';
import styled from 'styled-components';
import { MarketDetailsTab, RoutePath, generateRoutePath } from '../../app/router/config';
import { SettingsContext } from '../../context/settings';
import { TooltipContext } from '../../context/tooltip';
import { useActivities } from '../../hooks/market/use-activities';
import { TokenType } from '../../types/common';
import ActivityRow from './activitity-row';
import SkeletonTable from './skeleton/skeleton-table';
export default function ActivitiesTable(_a) {
    var filters = _a.filters, tokenType = _a.tokenType;
    var t = useI18n().t;
    var showFilters = useContext(SettingsContext).showFilters;
    var setTooltipProps = useContext(TooltipContext).setTooltipProps;
    var activities = useActivities(filters);
    function onBottomScroll() {
        activities.loadMoreOrders();
    }
    function getNumbering(order) {
        var _a, _b, _c;
        switch (tokenType) {
            case TokenType.CARD: {
                return (_a = order.card) === null || _a === void 0 ? void 0 : _a.numbering;
            }
            case TokenType.SOUVENIR_CARD: {
                return (_b = order.souvenirCard) === null || _b === void 0 ? void 0 : _b.numbering;
            }
            case TokenType.MINT_PASS: {
                return (_c = order.mintPass) === null || _c === void 0 ? void 0 : _c.numbering;
            }
            default: {
                return undefined;
            }
        }
    }
    var scrollRef = useBottomScrollListener(onBottomScroll);
    return (_jsxs(Container, { id: "market-activity-table", onScroll: function () { return setTooltipProps(undefined); }, ref: scrollRef, showFilters: showFilters, children: [!activities.orders && _jsx(SkeletonTable, {}), activities.orders &&
                activities.orders.map(function (order) {
                    var _a, _b, _c, _d, _e;
                    var numbering = getNumbering(order);
                    return (_jsx(ActivityRow, { date: moment(order.order.updated_timestamp).fromNow(), imageUrl: ((_a = order.order.sell.data.properties) === null || _a === void 0 ? void 0 : _a.image_url) || '', link: generateRoutePath(RoutePath.ASSET, {
                            tokenId: order.order.sell.data.token_id || '',
                            tab: MarketDetailsTab.OVERVIEW,
                        }), name: ((_b = order.order.sell.data.properties) === null || _b === void 0 ? void 0 : _b.name) || '', numbering: numbering, price: {
                            tokenSymbol: (_c = order.price.base) === null || _c === void 0 ? void 0 : _c.symbol,
                            value: ((_d = order.price.base) === null || _d === void 0 ? void 0 : _d.displayValue) || '',
                            usdValue: ((_e = order.price.usd) === null || _e === void 0 ? void 0 : _e.displayValue) || '',
                        }, sellerAddress: order.order.user }, order.order.order_id));
                }), activities.orders && activities.orders.length === 0 && (_jsx(NoResultContainer, { children: _jsx("p", { children: t('common.no-result') }) }))] }));
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  height: calc(100vh - 232px);\n  justify-content: flex-start;\n  overflow: auto;\n  padding: ", ";\n  transition: padding 200ms ease-in-out;\n  width: 100%;\n\n  @media screen and (max-width: 824px) {\n    padding: 40px 16px 96px 16px;\n  }\n"], ["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  height: calc(100vh - 232px);\n  justify-content: flex-start;\n  overflow: auto;\n  padding: ", ";\n  transition: padding 200ms ease-in-out;\n  width: 100%;\n\n  @media screen and (max-width: 824px) {\n    padding: 40px 16px 96px 16px;\n  }\n"])), function (_a) {
    var showFilters = _a.showFilters;
    return (showFilters ? '40px 32px 40px 312px' : '40px 32px');
});
var NoResultContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  height: 96px;\n  justify-content: center;\n  width: 100%;\n\n  & > p {\n    font-size: 16px;\n    font-weight: 400px;\n  }\n"], ["\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  height: 96px;\n  justify-content: center;\n  width: 100%;\n\n  & > p {\n    font-size: 16px;\n    font-weight: 400px;\n  }\n"])));
var templateObject_1, templateObject_2;
